import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const isochronesTransportComponent = () => (
    <div>
        <div style={{ padding: '10px' }}>
            <span className={styles.legendSubtitle}>{t`Изохроны доступности от остановок и станций общественного транспорта (400 метров)`}</span>
        </div>
    </div>
);

export const TransportIsochronesLegend = withDisplayedLayersCheck(isochronesTransportComponent, t`Изохроны доступности ОТ`);
